import React, { useEffect } from 'react';
import { Table, Tooltip, Typography, message, Tag } from 'antd';
import axios from 'axios';
import apiEndPoints, { headers } from 'configs/endPoints';
import { useSelector, useDispatch } from 'react-redux';
import useWindowDimensions from 'data/useWindowDimensions';
import constants from 'data/constants';
import { useHistory } from 'react-router-dom';
import moment from 'moment';


const AllFilesTable = (props) => {
	const columns = [
		{
			title: 'OwnerId',
			dataIndex: 'ownerId',
			key: 'ownerId'
		},
		{
			title: 'File Path',
			dataIndex: 'fileLocationUrl',
			key: 'fileLocationUrl'
		},
		{
			title: 'Type',
			dataIndex: 'fileExtention',
			key: 'fileExtention'
        },
        {
			title: 'Google FileId',
			dataIndex: 'googleDriveFileId',
			key: 'googleDriveFileId'
		},
		{
			title: 'Status',
			dataIndex: 'isActive',
			key: 'isActive'
		},
		{
			title: 'DateCreated',
			dataIndex: 'dateCreated',
			key: 'dateCreated'
		}
    ];

	const data = props.data && props.data.map(item => ({
        ...item,
        Key: item.id,
        isActive: item.isActive === true ? (<Tag color={'green'}>Active</Tag>) : (<Tag color={'red'}>Deactivated</Tag>),
		dateCreated: moment(item.dateCreated).format('YYYY-MM-DD hh:mm:ss'),
		fileLocationUrl: item.fileLocationUrl.startsWith('d3') ? <a href={'https://' + item.fileLocationUrl} target='_blank'>{item.fileLocationUrl}</a> : <a href={item.fileLocationUrl} target='_blank'>{item.fileLocationUrl}</a>,
    }))

	return <Table style={{overflowX: "scroll"}} dataSource={data} columns={columns} size="middle" />;
	//return <Table columns={columns} dataSource={tableData} size="middle" />;
};

export default AllFilesTable;
